<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

<div class="container pt-5">
  <div class="row justify-content-start">
    <div class="col-12">
      <div class="text-lg-start mb-4">
        <h3 class="mb-3 font-weight-normal">{{mode === 'update' ? 'Update Client': mode === 'view' ? 'View Client' :
          'Add Client'}}
        </h3>
      </div>
      <main class="form-signin border p-4 rounded">
        <form [formGroup]="addClientForm" (ngSubmit)="submit()">
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="companyName" id="companyName" type="text" placeholder="Company Name"
                  class="form-control" [class.is-invalid]="submitted && addClientForm.get('companyName')?.errors">
                <label for="companyName">Company Name</label>
                <span class="text-danger"
                  *ngIf="submitted && addClientForm.get('companyName')?.hasError('required')">Company Name
                  is required</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="address" id="address" type="text" placeholder="Address"
                  class="form-control" [class.is-invalid]="submitted && addClientForm.get('address')?.errors">
                <label for="address">Address</label>
                <span class="text-danger"
                  *ngIf="submitted && addClientForm.get('address')?.hasError('required')">Address is
                  required</span>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="region" id="region" type="text" placeholder="Region" class="form-control"
                  [class.is-invalid]="submitted && addClientForm.get('region')?.errors">
                <label for="region">Region</label>
                <span class="text-danger" *ngIf="submitted && addClientForm.get('region')?.hasError('required')">Region
                  is
                  required</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="website" id="website" type="text" placeholder="Website" class="form-control">
                <label for="website">Website</label>
              </div>
            </div>
          </div>
          <div *ngIf="mode !== 'view'" class="d-grid mt-4 px-1">
            <button class="btn btn-lg btn-info" type="submit" [disabled]="isSubmitDisabled || addClientForm.invalid">{{mode === 'update' ? 'Update Client' : 'Add Client'}}</button>
          </div>
        </form>
      </main>
    </div>
  </div>

  <!-- Members Section (visible only in edit/view mode) -->
  <div class="row justify-content-start mt-5" *ngIf="(mode === 'update' || mode === 'view') && addClientForm.get('id')?.value">
    <div class="col-12">
      <div class="text-lg-start mb-4">
        <h4 class="mb-3 font-weight-normal">Members</h4>
      </div>

      <!-- Members List -->
      <div *ngIf="members.length > 0" class="mb-4">
        <div *ngFor="let member of members; let i = index" class="border mb-3 rounded">
          <!-- Collapsed View (Header) -->
          <div class="p-3 bg-light d-flex justify-content-between align-items-center member-header"
            (click)="toggleMemberExpanded(i)">
            <div class="d-flex align-items-center flex-grow-1">
              <i class="material-icons me-2">{{expandedMembers[i] ? 'expand_less' : 'expand_more'}}</i>
              <span class="font-weight-bold">{{member.memberName || 'New Member'}}</span>
            </div>
          </div>

          <!-- Expanded View -->
          <div *ngIf="expandedMembers[i]" class="p-4 border-top">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="form-floating">
                  <input [(ngModel)]="member.memberName" id="memberName_{{i}}" type="text" placeholder="Member Name"
                    class="form-control" [class.is-invalid]="memberSubmitted && !member.memberName"
                    [disabled]="mode === 'view' || !member.isEditing">
                  <label for="memberName_{{i}}">Member Name</label>
                  <span class="text-danger" *ngIf="memberSubmitted && !member.memberName">Member Name is required</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-floating">
                  <input [(ngModel)]="member.email" id="email_{{i}}" type="email" placeholder="Email"
                    class="form-control" [class.is-invalid]="memberSubmitted && !member.email"
                    [disabled]="mode === 'view' || !member.isEditing">
                  <label for="email_{{i}}">Email</label>
                  <span class="text-danger" *ngIf="memberSubmitted && !member.email">Email is required</span>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="form-floating">
                  <input [(ngModel)]="member.mobile" id="mobile_{{i}}" type="text" placeholder="Mobile"
                    class="form-control" [class.is-invalid]="memberSubmitted && !member.mobile"
                    [disabled]="mode === 'view' || !member.isEditing">
                  <label for="mobile_{{i}}">Mobile</label>
                  <span class="text-danger" *ngIf="memberSubmitted && !member.mobile">Mobile is required</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-floating">
                  <input [(ngModel)]="member.skypeId" id="skypeId_{{i}}" type="text" placeholder="Skype ID"
                    class="form-control" [disabled]="mode === 'view' || !member.isEditing">
                  <label for="skypeId_{{i}}">Skype ID</label>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="form-floating">
                  <input [(ngModel)]="member.telephone" id="telephone_{{i}}" type="text" placeholder="Telephone"
                    class="form-control" [disabled]="mode === 'view' || !member.isEditing">
                  <label for="telephone_{{i}}">Telephone</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-check mt-3">
                  <input [(ngModel)]="member.isWhatsApp" id="isWhatsApp_{{i}}" type="checkbox" class="form-check-input"
                    [disabled]="mode === 'view' || !member.isEditing">
                  <label for="isWhatsApp_{{i}}" class="form-check-label">Is WhatsApp</label>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div *ngIf="mode !== 'view'" class="mt-4 d-flex">
              <button type="button" *ngIf="!member.isEditing" (click)="editMember(member)"
                class="btn btn-sm btn-warning me-2">
                <i class="material-icons" style="font-size: 18px; vertical-align: middle;">edit</i> Edit
              </button>
              <button type="button" *ngIf="member.isEditing" (click)="saveMember(member)"
                class="btn btn-sm btn-success me-2">
                <i class="material-icons" style="font-size: 18px; vertical-align: middle;">save</i> Save
              </button>
              <button type="button" *ngIf="member.isEditing" (click)="cancelMember(i, member)"
                class="btn btn-sm btn-secondary me-2">
                <i class="material-icons" style="font-size: 18px; vertical-align: middle;">close</i> Cancel
              </button>
              <button type="button" *ngIf="!member.isEditing" (click)="deleteMember(i, member)"
                class="btn btn-sm btn-danger">
                <i class="material-icons" style="font-size: 18px; vertical-align: middle;">delete</i> Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Add More Button -->
      <div *ngIf="mode !== 'view'" class="d-grid mt-3 px-1">
        <button type="button" (click)="addMember()" class="btn btn-outline-info">
          <i class="material-icons" style="font-size: 18px; vertical-align: middle;">add</i> Add More Member
        </button>
      </div>

      <!-- No Members Message -->
      <div *ngIf="members.length === 0 && (mode === 'update' || mode === 'view')" class="alert alert-info">
        No members added yet.
        <button type="button" *ngIf="mode !== 'view'" (click)="addMember()" class="btn btn-sm btn-info ms-2">
          Add Member
        </button>
      </div>
    </div>
  </div>
</div>

